import React, { ChangeEvent } from "react";
import uploadArrow from '../../assets/images/upload-arrow.svg';
import closeIcon from '../../assets/images/close-icon.svg';
import { checkFileType } from "../../utils/imageUpload";

// Define types for the props
interface FileUploadProps {
  id: string;
  tag: string;
  htmlFor: string;
  fileUrl?: string;
  clearImage: () => void;
  settingFileImageUrl: boolean;
  handleFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  fileUrlImageBase64?: string;
}

const FileUpload: React.FC<FileUploadProps> = ({
  id,
  tag,
  htmlFor,
  fileUrl,
  clearImage,
  settingFileImageUrl,
  handleFileUpload,
  fileUrlImageBase64,
}) => {
  return (
    <>
      {!fileUrl ? (
        <div className="col-md-6">
          <div className="col-md-6">
            <label htmlFor="firstname" className="label_text2 d-inline text-nowrap">
              {tag}<span className="text-danger">*</span>
            </label>
            <br />
            <label className="cursor-pointer" htmlFor={htmlFor}>
              <div className="pic_upload2 d-flex justify-content-between font-weight-bold pt-3 pr-3 px-2">
                {settingFileImageUrl ? (
                  <div className='center-v'>
                    <div className="spinner-border text-danger" role="status">
                      <span className="sr-only"></span>
                    </div>
                  </div>
                ) : (
                  <>
                    <p className="label_text">Click or drag <br /> and drop file</p>
                    <img className="img-fluid" src={uploadArrow} alt="Upload arrow" />
                  </>
                )}
              </div>
              <input
                onChange={handleFileUpload}
                id={id}
                className="input-file-type"
                type="file"
                accept="image/png, image/jpg, image/jpeg"
              />
            </label>
          </div>
        </div>
      ) : (
        <div className="col-md-6">
          <div className="img-upload-success-div">
            <div className="close-icon-signature-div">
              <div className="close-icon-img cursor-pointer">
                {!checkFileType(fileUrl) && (
                  <img src={closeIcon} onClick={clearImage} alt="Close icon" />
                )}
              </div>
              <div className="signature-img-div" style={{ marginTop: "20px" }}>
                {fileUrl && (
                  <>
                    {checkFileType(fileUrl) ? (
                      <label className="cursor-pointer" htmlFor={id}>
                        <div className="pic_upload2 d-flex justify-content-between font-weight-bold pt-3 pr-3 px-2">
                          <p className="label_text">PDF File Uploaded</p>
                          <img className="img-fluid" src={uploadArrow} alt="Upload arrow" />
                        </div>
                        <input
                onChange={handleFileUpload}
                id={id}
                className="input-file-type"
                type="file"
                accept="image/png, image/jpg, image/jpeg"
              />
                      </label>
                    ) : (
                      <img
                        src={fileUrlImageBase64}
                        width="70%"
                        height="120px"
                        style={{ zIndex: 1, margin: 'auto' }}
                        alt="Uploaded file"
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FileUpload;
